import React, { useEffect } from 'react';

export const HideEmergentBadge = () => {
  useEffect(() => {
    // Hide immediately
    const hideBadge = () => {
      const badge = document.getElementById('emergent-badge');
      if (badge) {
        badge.style.setProperty('display', 'none', 'important');
      }
    };
    
    hideBadge();
    
    // Also use a MutationObserver in case it's injected later
    const observer = new MutationObserver(() => {
      hideBadge();
    });
    
    observer.observe(document.body, { childList: true, subtree: true });
    
    return () => observer.disconnect();
  }, []);
  
  return null;
};
